import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER } from '../constants';
import { formatQueryParams } from '../helperFunctions';
import type { MapperItemConfig } from './types';

export const getStorePath = ({ slug, queryParams, source }: MapperItemConfig) => {
    const params: Record<string, any> = { store_name: slug };
    return pathfinder(PATHFINDER.STORE, params, formatQueryParams({ queryParams, source }));
};
